import { Controller } from "@hotwired/stimulus"

// Generic Stimulus controller for "add another row" pattern. Used by the
// wiki-admin navigation editor, home-page builder, and infobox layout editor.
export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    this.counter = this.rowsTarget.querySelectorAll("[data-row]").length || 100
  }

  addRow(event) {
    event.preventDefault()
    this.counter += 1
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.counter)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }
}
